// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    contactSalesButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Contact Sales Button Text",
        translatable: true
    },
    enterpriseButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Enterprise Button Text",
        translatable: true
    },
    enterpriseParagraph: {
        type: FIELD_TYPES.TEXT,
        label: "Enterprise Paragraph",
        translatable: true
    },
    enterpriseTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Enterprise Title",
        translatable: true
    },
    forresterButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Forrester Button Text",
        translatable: true
    },
    forresterCardTagline: {
        type: FIELD_TYPES.TEXT,
        label: "Forrester Card Tagline",
        translatable: true
    },
    forresterCardText: {
        type: FIELD_TYPES.TEXT,
        label: "Forrester Card Text",
        translatable: true
    },
    gartnerButtonText: {
        type: FIELD_TYPES.TEXT,
        label: "Gartner Button Text",
        translatable: true
    },
    gartnerCardTagline: {
        type: FIELD_TYPES.TEXT,
        label: "Gartner Card Tagline",
        translatable: true
    },
    gartnerCardText: {
        type: FIELD_TYPES.TEXT,
        label: "Gartner Card Text",
        translatable: true
    },
    sectionTagline: {
        type: FIELD_TYPES.TEXT,
        label: "Section Tagline",
        translatable: true
    },
    sectionTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Section Title",
        translatable: true
    },
    enterpriseButtonLink: {
        type: FIELD_TYPES.NESTED,
        label: "Enterprise Button Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
};
